import React, { useEffect, useState } from "react";
import { Button } from "@components/ui/button";
import { ChevronLeft, Delete, Download, Edit } from "lucide-react";
import useAuth from "@hooks/useAuth";
import AddCampaign from "./addCampaign";
import {
  CampaignMessages,
  getAllPublishedCampaignMessages,
} from "@redux/slices/campaign";
import LoadingScreen from "@components/LoadingScreen";
// @ts-ignore
import html2pdf from "html2pdf.js";
import { Checkbox } from "@mui/material";
import { useNavigate } from "react-router";
import { getUsers, UserAccount } from "@redux/slices/auth";

interface Props {
  onChange?: (value: string) => void;
}

const PublishedMessage: React.FC<Props> = ({ onChange }) => {
  const [messages, setMessages] = useState<CampaignMessages[]>();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<UserAccount[]>();
  const [selectedMessages, setSelectedMessages] = useState<number[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getData();
  }, [showModal]);

  // React.useEffect(() => {

  // }, [selectedUserId]);

  const getData = async () => {
    const data: CampaignMessages[] | null =
      await getAllPublishedCampaignMessages();
    const data1 = data?.filter(
      (i) => i.user_id === Number(window.location.pathname.split("/")[4])
    );
    const filteredData =
      window.location.pathname.split("/")[4] === "admin"
        ? data?.filter(
            (i) =>
              i.campaign_id == Number(window.location.pathname.split("/")[3])
          )
        : data1?.filter(
            (i) =>
              i.campaign_id == Number(window.location.pathname.split("/")[3])
          );
    setMessages(filteredData ?? undefined);

    const usersData = await getUsers();
    setUsers(usersData || []);
    console.log(users, usersData);
    setLoading(false);
  };

  const handleSelectMessage = (id: number) => {
    setSelectedMessages((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((messageId) => messageId !== id)
        : [...prevSelected, id]
    );
  };

  const downloadTemplate = () => {
    if (!selectedMessages.length || !messages) return;

    selectedMessages.forEach((messageId) => {
      const selectedMessage = messages.find((msg) => msg.id === messageId);
      if (!selectedMessage) return;

      const emailTemplate = `
        <div style="font-family: Arial, sans-serif; padding: 20px; background-color: #f4f4f4; max-width: 600px; margin: 0 auto;">
          <div style="background-color: #1CB5AF; color:white; font-size:16px;font-weight:500; text-align: center; padding: 10px; padding-bottom:24px;">
            <h1>${selectedMessage.subject}</h1>
          </div>
          <div style="padding: 20px; background-color: #fff; border: 1px solid #ddd;">
            <div style="font-size: 16px; line-height: 1.6; color: #333;">
              ${selectedMessage.message}
            </div>
          </div>
          <div style="text-align: center; margin-top: 30px; font-size: 14px; color: #888;">
            &copy; 2024 Your Company. All rights reserved.
          </div>
        </div>
      `;

      const tempElement = document.createElement("div");
      tempElement.innerHTML = emailTemplate;

      html2pdf()
        .from(tempElement)
        .set({
          margin: 1,
          filename: `${selectedMessage.subject}.pdf`,
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        })
        .save();
    });
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-between items-center mt-7">
            <h2 className="text-gray font-bold flex items-center sm:text-[22px] mb-8 text-lg capitalize ">
              <ChevronLeft
                size={22}
                className="me-3 cursor-pointer"
                onClick={() => navigate(-1)}
              />
              {/* {name !== null || "" ? name : "TM " + id} */}
              Published Messages
            </h2>
            <div className="flex">
              <Button
                variant="secondary"
                className="bg-white me-3"
                onClick={downloadTemplate}
                disabled={!selectedMessages.length}
              >
                <Download size={18} className="me-2" />
                Download
              </Button>
            </div>
          </div>
          {messages?.map((val) => (
            <div key={val.id} className="w-7/12">
              <div className="flex justify-between items-center mt-5">
                <h4 className="text-lg font-semibold flex items-center">
                  {users?.find((i: any) => i.id === val.user_id)?.email}
                </h4>
                <div className="flex items-center">
                  Download
                  <Checkbox
                    checked={selectedMessages.includes(val?.id || 0)}
                    onChange={() => handleSelectMessage(val?.id || 0)}
                  />
                </div>
              </div>
              <h6 className="text-gray px-3 py-1 bg-white rounded-sm text-sm mt-4">
                {val?.subject}
              </h6>
              <p
                className="text-gray px-3 pt-4 pb-5 bg-white rounded-sm text-sm mt-2"
                dangerouslySetInnerHTML={{ __html: val?.message }}
              ></p>
            </div>
          ))}
          <div className="pb-14"></div>
        </div>
      )}
    </>
  );
};

export default PublishedMessage;
